import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { RefinedInkRoot } from './RefinedInkRoot';
import { startNotificationAnalytics } from './lib/analyticsEvents';
import { installChunkReloadRecovery } from './lib/chunkReloadRecovery';
import { readOfflineScopes } from './features/events/offline/locators';

import './theme/refined-ink.css';
import './theme/partner-brand.css';

startNotificationAnalytics();
installChunkReloadRecovery();
// Retention also covers offline event data on a phone that never reopens the event.
if (readOfflineScopes().length > 0) {
  void import('./features/events/offline/vault').then(({ pruneExpiredEventVaults }) => pruneExpiredEventVaults()).catch(() => undefined);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RefinedInkRoot />
  </StrictMode>,
);
